export default __webpack_public_path__ + "static/media/basic-tutorial.337e2ed1.png";